import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule,
} from 'vuex-module-decorators';
import store from '@/stores/config/app-config-store';

export interface AppConfig {
  dataApiUrl: string;
  plausibleDataDomain: string;
  cookieDomain: string;
}

@Module({ dynamic: true, namespaced: true, name: 'AppConfigModule', store })
class AppConfigModule extends VuexModule {
  appConfig: AppConfig | null = null;
  loading = false;

  public get dataApiUrl(): string | undefined {
    return this.appConfig?.dataApiUrl;
  }

  public get plausibleDataDomain(): string | undefined {
    return this.appConfig?.plausibleDataDomain;
  }

  public get cookieDomain(): string | undefined {
    return this.appConfig?.cookieDomain;
  }

  public get isLoading(): boolean {
    return this.loading;
  }

  public get hasLoaded(): boolean {
    return this.appConfig != null;
  }

  @Mutation
  updateLoading(isLoading: boolean): void {
    this.loading = isLoading;
  }

  @Mutation
  updateConfig(appConfig: AppConfig): void {
    this.appConfig = appConfig;
  }

  @Action({ commit: 'updateConfig', rawError: true })
  async fetchAppConfig(): Promise<AppConfig | null> {
    this.updateLoading(true);

    const configResponse = await fetch('/app/api/config');
    if (!configResponse.ok) {
      const message = await configResponse.text();
      console.error(`App config could not be loaded: ${message}`);
      return null;
    }

    const config = await configResponse.json();
    if (!Reflect.has(config, 'dataApiUrl')) {
      throw Error('Expected app config to contain property dataApiUrl');
    }

    this.updateLoading(false);
    return config;
  }
}

export default getModule(AppConfigModule);
